/* eslint-disable array-callback-return */
/* eslint-disable indent */
/* eslint-disable quotes */
import React, { useState, useEffect, Fragment } from "react";
import Papa from "papaparse";

import { useSelector, useDispatch } from "react-redux";
import { Image } from "react-bootstrap";

import { userActions, ruleActions } from "../../../redux/actions";
import Button from "../../../component/button/Button";
import Card from "../../../component/card/Card";
import ErrorRender from "../../../component/request/ErrorRender";
import HeaderTag from "../../../component/smallComponents/HeaderTag";
import P from "../../../component/smallComponents/P";
import ResponseRender from "../../../component/request/ResponseRender";
import SelectInput from "../../../component/input/SelectInput";
import shiftChange_sample from "../../../images/shiftChange_sample.jpeg";
import shiftChange_sampleCSV from "../../../images/SAMPLE_CSV_SHIFT_CHANGE.csv";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import Starter from "../../../component/Starter";
import Strong from "../../../component/smallComponents/Strong";
import TextInput from "../../../component/input/TextInput";
import {
  getBrowserDetails,
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction,
  toastHelper,
  yearList
} from "../../../constant/helper/helper";
import { helperFunction } from "../../../constant/helper";
import ShiftTable from "./ShiftTable";

const initialState = {
  locationId: "",
  dataType: "REGISTER",
  month: "",
  year: ""
};

const ShiftChange = () => {
  const loginType = localStorage.loginType;

  const dispatch = useDispatch();
  const [CsvData, setCsvData] = useState([]);
  const [csvFile, setCsvFile] = useState(null);
  const [response, setResponse] = useState("");
  const [values, setValues] = useState(initialState);
  const [allLocations, setAllLocations] = useState([]);

  const { currentUser } = useSelector((state) => state.auth);
  const { locations } = useSelector((state) => state.location);

  const showYearOptions = Object.values(yearList).map(
    (type, index) => (
      <option value={type} key={index}>
        {type}
      </option>
    )
  );

  const {
    shiftError,
    shiftResponse,
    shiftLoading,
    shiftChangesError
  } = useSelector((state) => state.user);

  useEffect(() => {
    setAllLocations(locations);
  }, [locations]);

  useEffect(() => {
    if (shiftError) {
      helperFunction.toastHelper("error", shiftError);
    }
  }, [shiftError]);

  useEffect(() => {
    setResponse(shiftResponse);
  }, [shiftResponse]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "locationId") {
      dispatch(ruleActions.getAllRulesByLocationId(value, loginType));
    }
    setValues({
      ...values,
      [name]: value
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const browserDetail = await getBrowserDetails();
    const os = browserDetail.os.name;
    const browser = browserDetail.browser.name;

    const userCsvToJsonData = {
      CsvData,
      ipAddress: localStorage?.publicIpAdd,
      locationId: values.locationId,
      deviceDetails: os + "-" + browser,
      latitude: localStorage.latitude,
      longitude: localStorage.longitude,
      dataType: values.dataType,
      month: values.month,
      year: values.year
    };

    console.log(csvFile);
    dispatch(userActions.setShiftLoading(true));
    dispatch(userActions.clearShiftErrors());
    dispatch(userActions.clearShiftResult());
    dispatch(userActions.shiftChange(userCsvToJsonData, loginType));
  };

  useEffect(() => {
    dispatch(userActions.setShiftLoading(false));
    dispatch(userActions.clearShiftErrors());
    dispatch(userActions.clearShiftResult());
    return () => {
      setCsvFile(null);
      dispatch(userActions.setShiftLoading(false));
      dispatch(userActions.clearShiftErrors());
      dispatch(userActions.clearShiftResult());
    };
  }, []);
  // handle file upload
  const convertingCsvIntoJson = (csvFile) => {
    const csvRequiredFiled = [
      "EmployeeId",
      "fromDate",
      "toDate",
      "shiftType",
      "woDay"
    ];

    Papa.parse(csvFile, {
      header: true,
      skipEmptyLines: "greedy", // drop blank lines safely
      transformHeader: (h) => (h || "").trim(), // trim header keys
      transform: (v) => (typeof v === "string" ? v.trim() : v), // trim every cell
      complete: ({ data, errors }) => {
        try {
          // Optionally log parse errors from Papa
          if (errors && errors.length) {
            console.warn("Papa parse warnings/errors:", errors);
          }

          // Filter out rows that are entirely empty (all values blank after trim)
          const cleanedRows = data.filter((row) =>
            Object.values(row).some(
              (val) => String(val ?? "").trim() !== ""
            )
          );

          const jsonData = cleanedRows.map((row, index) => {
            // Validate required fields after trimming
            csvRequiredFiled.forEach((requiredField) => {
              const val = row[requiredField];
              if (val === undefined || String(val).trim() === "") {
                throw new Error(
                  `Missing or empty value for required field "${requiredField}" in row ${
                    index + 1
                  }`
                );
              }
            });

            return row;
          });

          console.log(jsonData);
          setCsvData(jsonData);
        } catch (error) {
          return toastHelper("error", error.message);
        }
      }
    });
  };

  const renderExcel = (
    <div className="row mt-3">
      <ShiftTable data={CsvData} />
    </div>
  );

  const topInput = (
    <form onSubmit={onSubmit}>
      <div className="row mb-2">
        <div className="col-md-2 mt-2 col-xl-2 col-lg-2">
          <SelectInput
            required={true}
            textWhite={false}
            isLabeled={false}
            label="Select Location"
            name="locationId"
            value={values.locationId}
            onChange={handleInputChange}
          >
            <option value=""> Select Location</option>
            {isSuperAdmin(currentUser)
              ? renderLocationFunction(allLocations)
              : renderAccessLocation2(
                  locationRender(currentUser, false)
                )}
          </SelectInput>
        </div>
        <div className="col-md-2 mt-2 col-xl-2 col-lg-2">
          <SelectInput
            required={true}
            name="dataType"
            textWhite={false}
            isLabeled={false}
            label="Select Type"
            value={values.dataType}
            onChange={handleInputChange}
          >
            <option value=""> Select Type</option>
            <option value="REGISTER"> REGISTER</option>
            <option value="UPDATE"> UPDATE</option>
          </SelectInput>
        </div>
        <div className="col-md-2 mt-2 col-xl-2 col-lg-2">
          <SelectInput
            required={true}
            name="month"
            textWhite={false}
            isLabeled={false}
            label="Select month"
            value={values.month}
            onChange={handleInputChange}
          >
            <option value=""> Select Month</option>
            <option value="01"> JANUARY</option>
            <option value="02"> FEBRUARY</option>
            <option value="03"> MARCH</option>
            <option value="04"> APRIL</option>
            <option value="05"> MAY</option>
            <option value="06"> JUNE</option>
            <option value="07"> JULY</option>
            <option value="08"> AUGUST</option>
            <option value="09"> SEPTEMBER</option>
            <option value="10"> OCTOBER</option>
            <option value="11"> NOVEMBER</option>
            <option value="12"> DECEMBER</option>
          </SelectInput>
        </div>
        <div className="col-md-2 mt-2 col-xl-2 col-lg-2">
          <SelectInput
            required={true}
            name="year"
            textWhite={false}
            isLabeled={false}
            label="Select Year"
            value={values.year}
            onChange={handleInputChange}
          >
            <option value=""> Select Year</option>
            {showYearOptions}
          </SelectInput>
        </div>

        <div className="col-md-3 mt-3 col-xl-3 col-lg-3">
          <TextInput
            type="file"
            file={true}
            required={true}
            textWhite={false}
            htmlFor="xlFile"
            accept=".csv"
            onChange={(e) => {
              const csvFile = e.target.files[0];
              convertingCsvIntoJson(csvFile);
              setCsvFile(csvFile);
            }}
            label="Add CSV File to Shift Changes of Multiple User"
          />
        </div>
        <div className="form-group text-center col-sm-2 mt-5 col-xl-2 col-l-2">
          {shiftLoading ? (
            <SpinnerButton />
          ) : (
            <Button
              type="submit"
              title="Submit"
              isBackgroundColor={false}
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn text-white btn-block btn-dark"
            />
          )}
        </div>
      </div>
    </form>
  );

  return (
    <Starter
      topBarTitle="Shift Changes"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">HR Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">HR</a>
          </li>
          <li className="breadcrumb-item active">Shift Changes</li>
        </Fragment>
      }
    >
      <div className="row">
        <div className="col-lg-12">
          <Card>
            <div className="row">
              <div className="col-lg-12">
                <Strong
                  title="All inputs are compulsory*"
                  className="text-danger float-right"
                />
                <HeaderTag
                  type="h4"
                  title="Shift Changes XL List"
                  isClassName={false}
                />
                <P title="Fill the form below Shift Change List" />
                <HeaderTag
                  type="h4"
                  title="[ SYSTEM ONLY ACCEPT CSV FILE ]"
                  className="text-danger"
                  isClassName={true}
                />
              </div>
            </div>
            {topInput}
            {shiftChangesError &&
              shiftChangesError?.map((data, i) => (
                <ErrorRender errors={data} key={i} />
              ))}
            {response && <ResponseRender response={response} />}
          </Card>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-lg-12">
          <button>
            <a href={shiftChange_sampleCSV} download>
              Download Sample XLSX File To Change Shift
            </a>
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-5">
          <Image src={shiftChange_sample} fluid />
        </div>
        <div className="col-lg-7">
          <Card>{renderExcel}</Card>
        </div>
      </div>
    </Starter>
  );
};

export default ShiftChange;
